import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { CssTextField } from 'components/select';
import ProvisioningStyles from 'pages/provisioning/vm/style';

const StaticText = ({ label, value, ...props }) => {
    return (
        <Box sx={{ ...ProvisioningStyles.box, width: '100%' }}>
            <CssTextField
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                label={label}
                value={value || ''}
                disabled
                fullWidth
                variant="outlined"
                {...props}
            />
        </Box>
    );
};

StaticText.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

StaticText.defaultProps = {
    value: '',
};

export default React.memo(StaticText);
